"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeSubjectsClient = void 0;
class FakeSubjectsClient {
    constructor() {
        this.subjects = [];
    }
    insertSubject(subject) {
        this.subjects.push(subject);
    }
    getAll() {
        return Promise.resolve(this.subjects);
    }
    getMarketSegmentSubjects(_marketSegment) {
        return Promise.resolve(this.subjects);
    }
    async update(currentSubject, updateRequest) {
        if (!currentSubject.links?.update) {
            throw new Error('Update link not available');
        }
        const subject = this.subjects.find((it) => it.id === currentSubject.id);
        subject.name = updateRequest.name;
    }
    clear() {
        this.subjects = [];
    }
}
exports.FakeSubjectsClient = FakeSubjectsClient;
//# sourceMappingURL=FakeSubjectsClient.js.map